import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import {
  Button,
  TextField,
  ThemeProvider,
  createTheme,
  IconButton,
  Grid,
  Typography,
  TableContainer,
  Select,
  InputLabel,
  MenuItem,
  Tooltip,
  DialogTitle,
  Dialog,
  DialogContent,
  CircularProgressProps,
  CircularProgress,
  DialogActions,
  FormControl,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import useStyles from "../../../../../../css/styles_PE";
import { ApptContext, SupportFile } from "../../../../../../store";
import {UploadDocuments} from "../../../../../../api/PE_API"; //FB 9372
import { useNavigate, useParams } from "react-router-dom";
import { Delete } from "@mui/icons-material";
import { Buffer } from "buffer";
import { InsertPPLogs,GetDocumentCategories,GetAdminSettingValue } from "../../../../../../api"; //FB 9372 FB 10815

// Update log
// FB  6192   02/06/2023  DK  Page to upload support documents
// FB  7112   07/20/2023  SK  Patient Portal: Add a new option to upload the insurance data below the Upload clinical documents option
// FB  7129   09/05/2023  SK  Improve GUI For Updating Documents on PE and Portal
// FB  9372   09/13/2024  GA  Portal UI should not call EMR APIs Directly
// FB  10815   08/07/2025  GA  Admin setting for PE/Portal upload document screen

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box style={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        style={{ color: "#18a2b8" }}
        {...props}
      />
      <Box
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></Box>
    </Box>
  );
}

export default function FileUpload(props: any) {
  var encodedAppt_n = "";
  var decodedAppt_n = "";
  var { apptId } = useParams();
  if (apptId != undefined) {
    encodedAppt_n = apptId;
    decodedAppt_n = Buffer.from(encodedAppt_n, "base64").toString();
  }
  const navigate = useNavigate();
  const [documentType, setDocumentType] = useState<any>("");
  const [otherDocument, setOtherDocument] = useState<any>("");
  const [inputList, setInputList] = useState<SupportFile[]>([]);
  const { state } = useContext(ApptContext);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [progress, setProgress] = useState(10);
  const [buttonLabel, setButtonLabel] = useState("Cancel");
  //FB 10815
  const [uploadDocumentText, setUploadDocumentText] = useState<string>("To reduce your time in the office, Please upload documents to your electronic chart including: Your driver's license, Insurance card or Any important medical documents such as Lab results, Pathology reports, Relevant images.");
  const styles = useStyles();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
    overrides: {
      MuiFormLabel: {
        asterisk: {
          color: "red",
        },
      },
    },
  });
  var JSAlert = require("js-alert");
  const [DocumentCategories, setDocumentCategories] = useState([]);
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  //FB 10815
  async function GetUploadDocumentText() {
    var data = await GetAdminSettingValue("upload_document_screen_text");
    if (data != null && data != "") {
        setUploadDocumentText(data);
    } else {
        console.log("Admin setting is null/empty, using default text");
    }
  }
  const useSmartphoneClick = async () => {
    var encodedDocType = Buffer.from(documentType).toString("base64");
    InsertPPLogs(
      "Clicked on Use Smartphone - Upload files",
      window.location.href,
      userName,
      ""
    );
    //FB 7129 - Begin
    if (isDisabled == false) {
      setDocumentType("Insurance card");
    }
    else {
      setDocumentType("");
    }
    //FB 7129 - End
    window.open(
      "/user/fileupload/qrcode/" + encodedAppt_n + "/" + encodedDocType
    );
  };
  const addInputDocument = (e: any) => {
    const file = e.target.files[0];
    const fileSize = Number((file.size / (1024 * 1024)).toFixed(3));
    if (inputList.some((doc) => doc.FileName === file.name)) {
      JSAlert.alert(
        "File already exists. Please select a different file",
        null,
        JSAlert.Icons.Warning
      );
    } else {
      if (
        (file.type === "application/pdf" ||
          file.type === "image/png" ||
          file.type === "image/jpeg") &&
        fileSize > 0
      ) {
        if (fileSize <= 6) {
          const reader = new FileReader();
          InsertPPLogs(
            "Clicked on Choose file(s) - Upload files",
            window.location.href,
            userName,
            ""
          );
          reader.onload = () => {
            const input = {
              DocumentType: documentType,
              OtherDocument: otherDocument,
              FileName: file.name,
              FileType: file.type,
              FileSize: fileSize,
              Base64EncodedFile: reader.result?.toString().split("base64,")[1],
              Appointment_N: Number(decodedAppt_n),
              previewUrl: URL.createObjectURL(file) //FB 7129
            } as SupportFile;
            setInputList([...inputList, input]);
            //FB 7129-Begin
            if (isDisabled == false) {
              setDocumentType("Insurance card");
            }
            else {
              setDocumentType("");
            }
            //FB 7129-End
            setOtherDocument("");
            setButtonLabel("Cancel");
          };
          reader.readAsDataURL(file);
        } else {
          JSAlert.alert(
            "Please select a file smaller than 6MB",
            null,
            JSAlert.Icons.Warning
          );
        }
      } else {
        JSAlert.alert(
          "Invalid file type. Please select a valid file",
          null,
          JSAlert.Icons.Warning
        );
      }
    }
  };
  const handleRemoveClick = (index: number) => {
    InsertPPLogs(
      "Clicked on Delete - Upload files",
      window.location.href,
      userName,
      ""
    );
    var alert = new JSAlert(
      "Are you sure you want to delete this file?",
      "",
      JSAlert.Icons.Question
    );
    alert.addButton("Yes").then(function () {
      inputList.splice(index, 1);
      setInputList([...inputList]);
      InsertPPLogs(
        "Clicked on yes - Upload files",
        window.location.href,
        userName,
        ""
      );
      //FB 7129 - Begin
      if (isDisabled == false) {
        setDocumentType("Insurance card");
      }
      //FB 7129 - End
    });
    alert.addButton("No").then(function () {
      InsertPPLogs(
        "Clicked on no - Upload files",
        window.location.href,
        userName,
        ""
      );
      return;
    });
    alert.show();
  };
  const submitDocuments = async () => {
    InsertPPLogs(
      "Clicked on Upload to my chart - Upload files",
      window.location.href,
      userName,
      ""
    );
    setDisableSubmit(true);
    setOpenDialog(true);
    const result = await UploadDocuments(inputList, Number(decodedAppt_n));
    if (result === 200) {
      setOpenDialog(false);
      JSAlert.alert(
        "File(s) uploaded successfully!",
        null,
        JSAlert.Icons.Success
      );
      setButtonLabel("Done");
      setInputList([]);
    } else {
      setOpenDialog(false);
      setDisableSubmit(false);
      setButtonLabel("Cancel");
    }
  };
  const handleDone = () => {
    if (buttonLabel == "Cancel") {
      InsertPPLogs(
        "Clicked on Cancel - Upload files",
        window.location.href,
        userName,
        ""
      );
    } else if (buttonLabel == "Done") {
      InsertPPLogs(
        "Clicked on Done - Upload files",
        window.location.href,
        userName,
        ""
      );
    }
    navigate("/user/bookappointment/closure", { state: { origin: "upload" } });
  };
  const SelectDocumentType = async (e: any) => {
    setDocumentType(e.target.value);
    InsertPPLogs(
      "Selected the document " + e.target.value,
      window.location.href,
      userName,
      ""
    );
  };

  //FB 7112 - Begin
  const [isDisabled, setIsDisabled] = useState(true);
  function InsuranceCard() {
    let ins = sessionStorage.getItem("InsuranceCard");
    if (ins == "insuranceCard") {
      setDocumentType("Insurance card");
      setIsDisabled(false);
    }
  }
  //FB 7112 - End
  useEffect(() => {
    GetDocumentCategories().then((data) => {
      setDocumentCategories(data.split(","));
    });
    //FB 10815
    GetUploadDocumentText();
  }, []);
  //FB 7112 - Begin
  useEffect(() => {
    InsuranceCard();
  }, []);
  //FB 7112 - End

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    inputList.length > 0 ? setDisableSubmit(false) : setDisableSubmit(true);
  }, [inputList]);

  return (
    <Box
      sx={{
        width: "100%",
        padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body1">
            {/*FB 10815*/}
            {uploadDocumentText}
          </Typography>
        </Grid>
      </Grid>

      <div>
        <Grid
          container
          spacing={3}
          style={{
            display: "flex",
            alignItems: "center",
            //FB 7112 - Begin
            justifyContent: isDisabled == true ? "center" : "",
            paddingLeft: isDisabled == false ? "10px" : "",
            //FB 7112 - End
            marginTop: "1%",
          }}
        >
          {/* FB 7112  */}
          {isDisabled && (
            <Grid item xs={window.innerWidth <= 768 ? 12 : 4}>
              <ThemeProvider theme={theme}>
                <FormControl required fullWidth>
                  <InputLabel id="for_documenttype">Document category</InputLabel>
                  <Select
                    labelId="for_documenttype"
                    value={documentType}
                    //onChange={e => setDocumentType(e.target.value)}
                    onChange={(e) => SelectDocumentType(e)}
                    name="document_type"
                  >
                    {DocumentCategories.map((item: string) => (
                      <MenuItem value={item}> {item} </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ThemeProvider>
            </Grid>
            // FB 7112
          )}
          {isDisabled && (
            <Grid
              item
              xs={window.innerWidth <= 768 ? 12 : 3}//FB 7129
              style={{ display: documentType === "other" ? "block" : "none" }}
            >
              <ThemeProvider theme={theme}>
                <TextField
                  label="Please specify the other document"
                  variant="standard"
                  name="other_document"
                  value={otherDocument}
                  onChange={(e) => setOtherDocument(e.target.value)}
                  fullWidth
                />
              </ThemeProvider>
            </Grid>
            //FB 7112
          )}
          {!isDisabled && <label>Insurance Card</label>}
          <Grid item xs={window.innerWidth <= 768 ? 12 : 4} style={{ display: "flex", alignItems: "center" }}>{/* FB 7129 */}
            <Button
              variant="contained"
              component="label"
              className={styles.navigationButton}
              disabled={documentType.length > 0 ? false : true}
            >
              Choose File
              <input
                type="file"
                name="document_path"
                onChange={(e) => addInputDocument(e)}
                onClick={(event) => {
                  event.currentTarget.value = "";
                }}
                accept="image/*,.pdf"
                hidden
              />
            </Button>

            {/* FB 7129-Begin*/}
            <span style={{ marginLeft: "10px", fontSize: "0.85rem" }}>
              <label>(Accepted file types:</label><br />
              <label> pdf, jpg, jpeg, png. Max size: 6 MB)</label>
            </span>
            {/* FB 7129-End*/}
          </Grid>

          <Grid item xs={3}>{/* FB 7129 */}
            <Button
              variant="contained"
              component="label"
              className={styles.navigationButton}
              onClick={useSmartphoneClick}
              disabled={documentType.length > 0 ? false : true}
            //FB 7129 - Deleted Unused Paart Of Code 
            >
              Use Smartphone
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          style={{
            paddingLeft: "45px" //FB 7129 - Deleted unused part of code
          }}
        >
          <Grid
            item
            xs={documentType === "other" || window.innerWidth <= 768 ? 12 : 8}
          >
            <span style={{ color: "red" }}>* Mandatory fields</span>
          </Grid>
        </Grid>
      </div>

      <div style={{ marginBottom: "inherit" }}>{/* FB 7129 - Deleted unused part of code*/}
        <Grid
          container
          style={{
            display: inputList.length > 0 ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/*FB 4955*/}
          <Grid
            item
            xs={12}// FB 7129
            style={{ marginTop: 10, overflow: "hidden" }}//FB 7129
          >
            <TableContainer >{/* FB 7129 */}
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      colSpan={6}//FB 7129
                      style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                    >
                      Selected files
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontSize: "1rem" }}>
                      Document Category
                    </TableCell>
                    <TableCell style={{ fontSize: "1rem" }}>Name</TableCell>
                    <TableCell style={{ fontSize: "1rem" }}>Size</TableCell>
                    <TableCell style={{ fontSize: "1rem" }}>Preview</TableCell>{/* FB 7129 */}
                    <TableCell style={{ fontSize: "1rem" }}>Tools</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inputList.map((input, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {input.DocumentType === "other"
                            ? input.OtherDocument
                            : input.DocumentType}
                        </TableCell>
                        <TableCell>{input.FileName}</TableCell>
                        <TableCell>{input.FileSize + " MB"}</TableCell>
                        {/* FB 7129-Begin*/}
                        <TableCell>{input.FileType.includes('image') ? (
                          <img
                            src={input.previewUrl}
                            alt={`Preview ${index + 1}`}
                            style={{ maxWidth: '50%', height: 'auto' }}
                          />
                        ) : (
                          <embed src={input.previewUrl} type="application/pdf" width="100%" height="600px" />
                        )}</TableCell>
                        {/* FB 7129-End */}

                        <TableCell>
                          <Tooltip title="Delete">
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemoveClick(index)}
                              size="small"
                            >
                              <Delete fontSize="small" color="error" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
      {/* FB 7129 - Begin */}
      <Grid container spacing={3} className={styles.flexend_Grid}>
        <Grid
          style={{
            margin: "25px"
          }}
        >{/* FB 7129- End*/}
          <Button
            onClick={submitDocuments}
            variant="contained"
            id="submit"
            className={styles.navigationButton}
            style={{ display: disableSubmit ? "none" : "", marginRight: "5px" }}//FB 7129
          >
            Upload to my chart
          </Button>
          {/* FB 7129 - Deleted unused part of code*/}
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleDone}
            style={{ width: 100 }}
          >
            {buttonLabel}
          </Button>
        </Grid>
      </Grid>

      <Dialog open={openDialog} disableBackdropClick fullWidth maxWidth={"xs"}>
        <DialogTitle
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Typography style={{ color: "#18a2b8" }}>Uploading...</Typography>
        </DialogTitle>
        <DialogContent
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgressWithLabel value={progress} />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </Box>
  );
}